import { defineStore } from 'pinia'
import api from '@/services/api'

export const useLookupStore = defineStore('lookups', {
  state: () => ({
    departments: []
  }),
  actions: {
    async load () {
      try {
        const { data } = await api.get('/departments') // baseURL ya incluye /api
        this.departments = Array.isArray(data) ? data : []
      } catch (e) {
        // Si no hay token aún (pantalla de login), no pasa nada
        if (e?.response?.status === 401) {
          this.departments = []
          return
        }
        console.error('lookup load error', e?.response?.data || e)
        throw e
      }
    }
  }
})
